<template>
<div>
  <navigation :frontpage="true"></navigation>
</div>
</template>

<script>
import Navigation from "./Navigation";

export default {
  name: "Frontpage",

  components: {
    Navigation
  }
};
</script>
